"use client"

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNextCustom,
  CarouselPreviousCustom,
} from "@/components/ui/carousel"
import Image from "next/image"
import Link from "next/link"
import { useIsMobile } from "@/hooks/use-is-mobile"

const categories = [
  {
    name: "Squirrel Proof Feeders",
    image: "/home/category/featured-category-1.png",
    link: "/squirrel-proof-feeders",
  },
  {
    name: "Hummingbird Feeders",
    image: "/home/category/featured-category-6.png",
    link: "/hummingbird-feeder",
  },
  {
    name: "Cardinal Feeders",
    image: "/home/category/featured-category-7.png",
    link: "/cardinal-feeders",
  },
  {
    name: "Bluebird Feeders",
    image: "/home/category/featured-category-8.png",
    link: "/bluebird-feeders",
  },
  {
    name: "Weatherproof Bird Feeders",
    image: "/home/category/featured-category-2.png",
    link: "/weatherproof-bird-feeders",
  },
  {
    name: "Suet Bird Feeders",
    image: "/home/category/featured-category-3.png",
    link: "/suet-bird-feeder",
  },
  {
    name: "Platform Bird Feeders",
    image: "/home/category/featured-category-4.png",
    link: "/platform-feeders",
  },
  {
    name: "Tube Bird feeders",
    image: "/home/category/featured-category-5.png",
    link: "/tube-bird-feeders",
  },

  {
    name: "Blue Jay Feeders",
    image: "/home/category/featured-category-9.png",
    link: "/blue-jay-feeders",
  },
]

const FeaturedCategories = (props) => {
  const { hideTitile = false } = props

  const { isMobile } = useIsMobile()

  if (isMobile) {
    return (
      <div className="px-[19.5px] py-[40px]">
        {!hideTitile && (
          <p className="mb-[20px] font-poppins text-[22px] font-[600] leading-[1.4] text-title">
            Featured Categories
          </p>
        )}
        <div className="grid grid-cols-3 grid-rows-3 gap-x-[10px] gap-y-[20px]">
          {categories.map((item, index) => (
            <Link
              href={item.link}
              key={index}
              className="flex cursor-pointer flex-col items-center"
            >
              <Image
                className="h-auto w-full select-none"
                src={item.image}
                alt=""
                width={406}
                height={405}
                layout="responsive"
              />
              <div className="mt-[10px] max-w-[105px] cursor-pointer text-center font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline">
                {item.name}
              </div>
            </Link>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="mt-[60px]">
      {!hideTitile && (
        <div className="mx-auto w-[1440px]">
          <p className="mb-[40px] font-poppins text-[30px] font-[600] leading-[1.4] text-title">
            Featured Categories
          </p>
        </div>
      )}
      <div className="mx-auto mt-[40x] w-[1440px]">
        <Carousel className="w-full">
          <CarouselContent className="">
            {categories.map((item, index) => (
              <CarouselItem key={index} className="basis-full lg_basis-1/5">
                <Link
                  href={item.link}
                  className="group flex cursor-pointer flex-col items-center px-[10px]"
                >
                  <Image
                    className="h-auto w-full select-none"
                    src={item.image}
                    alt=""
                    width={406}
                    height={405}
                    layout="responsive"
                  />
                  <div className="mt-[22px] max-w-[160px] text-center font-poppins  text-[20px] font-[600] leading-[1.4] text-title group-hover_text-primary group-hover_underline">
                    {item.name}
                  </div>
                </Link>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPreviousCustom className="absolute hidden bg-transparent hover_bg-transparent lg_block" />
          <CarouselNextCustom className="absolute hidden bg-transparent hover_bg-transparent lg_block" />
        </Carousel>
      </div>
    </div>
  )
}

export default FeaturedCategories
